/** @internal */
export const OP_DONE = "Done";
/** @internal */
export const OP_EMIT = "Emit";
/** @internal */
export const OP_FROM_EFFECT = "FromEffect";
/** @internal */
export const OP_READ = "Read";
//# sourceMappingURL=channelState.js.map